// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".app__EditBuilding__cpEditBuildingContainer{margin-top:var(--GW-LAYOUT-8)}", "",{"version":3,"sources":["webpack://./../common/capabilities-react/gw-capability-gateway-quoteandbind-cp-react/components/EditBuilding/EditBuilding.module.scss"],"names":[],"mappings":"AAAA,4CACI,6BAAA","sourcesContent":[".cpEditBuildingContainer {\n    margin-top: var(--GW-LAYOUT-8);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cpEditBuildingContainer": "app__EditBuilding__cpEditBuildingContainer"
};
export default ___CSS_LOADER_EXPORT___;
